import React, { FC } from 'react'
import { useModal } from '@shared/lib'
import { useBreakpoint } from '@shared/lib/react'
import { TextButton } from '@shared/ui/atoms'
import RegionsWithRestrictionsIntructionModalDesktop from './RegionsWithRestrictionsIntructionModalDesktop'
import RegionsWithRestrictionsIntructionModalMobile from './RegionsWithRestrictionsIntructionModalMobile'

const RegionsWithRestrictionsIntructionButton: FC = () => {
  const { isModalActive, handleModalClose, handleModalOpen } = useModal()

  const { isMobile } = useBreakpoint()

  return (
    <>
      <TextButton onClick={handleModalOpen}>регионов с&nbsp;ограничениями</TextButton>
      {isMobile ? (
        <RegionsWithRestrictionsIntructionModalMobile open={isModalActive} onClose={handleModalClose} />
      ) : (
        <RegionsWithRestrictionsIntructionModalDesktop open={isModalActive} onClose={handleModalClose} />
      )}
    </>
  )
}

export default RegionsWithRestrictionsIntructionButton
